import Button from "@/common/elements/Button";
import DataTable from "@/common/elements/DataTable";
import Modal from "@/common/elements/Modal";
import Popconfirm from "@/common/elements/Popconfirm";
import { StyledFlex } from "@/common/styles";
import { InmateDetailsTableContainer } from "@/components/InmateDetails/styles";
import { useState } from "react";
import TrainingClassForm from "./TrainingClassForm";
import useGridColumnConfig from "@/hooks/useGridColumnConfig";

const TRAINING_HEADERS = [
  {key:"id",text:"ID"},
  {key:"className",text:"Class Name"},
  {key:"scheduledDate",text:"Scheduled Date And Time"},
  {key:"completedDate",text:"Completed Date"},
  {key:"hours",text:"Hours"},
];

const TrainingClassDetails = ( ) => {
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [selectedRow, setSelectedRow] = useState(null);

    const [tableData,setTableData] = useState({
        headers: TRAINING_HEADERS,
        rows:[]
    })

    // "Config" — drag-reorder/resize columns, persisted per-user (see
    // docs/plans/grid-column-config-feature.md). This tab is still a
    // non-functional stub (no real data wired up yet, see
    // docs/plans/grid-column-config-other-modules-rollout.md §3.1), so this
    // is just the Config wiring on top of the stub as it stands today.
    const {
      headers: trainingHeaders,
      isConfiguring,
      configButtonLabel,
      startConfiguring,
      confirmSave,
      discardChanges,
      dataTableRef,
    } = useGridColumnConfig("Staff:Training", TRAINING_HEADERS);

    const onHandleModalOpen = () => {
      if (!selectedRow) return;
      setIsModalVisible(true)
    }
    const onHandleModalClose = () => {
      setIsModalVisible(false)
    }
    const onRowClick = (row) => {
      setSelectedRow(row);
    }

    return(
        <>
        <InmateDetailsTableContainer>
                {/* Matches ASP's CreateList "TrainingClassMember" call in
                    StaffInterface.asp (fIncludeAdd=False, fIncludeDetails=True,
                    fIncludeDelete=False) - Details only, no Add/Delete. */}
                <StyledFlex gap="10px" justify="end" style={{ marginBottom: "10px" }}>
                  <Button
                    color="primary"
                    type="primary"
                    disabled={!selectedRow || isConfiguring}
                    onClick={onHandleModalOpen}>
                    Details
                  </Button>

                  {/* Config — drag-reorder/resize columns */}
                  {!isConfiguring ? (
                    <Button htmlType="button" onClick={startConfiguring}>
                      {configButtonLabel}
                    </Button>
                  ) : (
                    <Popconfirm
                      title="Do you want to save the current list view configuration?"
                      onConfirm={confirmSave}
                      onCancel={discardChanges}
                      okText="Yes"
                      cancelText="No"
                    >
                      <Button htmlType="button">{configButtonLabel}</Button>
                    </Popconfirm>
                  )}
                </StyledFlex>

                <DataTable
                  ref={dataTableRef}
                  headers={trainingHeaders}
                  draggable={isConfiguring}
                  data={tableData.rows}
                  onRowClick={onRowClick}
                />

              </InmateDetailsTableContainer>
              
              { isModalVisible && (
              <Modal 
              show={isModalVisible}
              header="Training Class Member Details"
              size="xl"
              handleCancel={onHandleModalClose}
              onHide={onHandleModalClose}>
                
                <TrainingClassForm />
              
              </Modal>
              )}
        </>
    )
} 
export default TrainingClassDetails;